import styled from "styled-components";

// styles based on old Tridion carousel from GFI
export const ThreeSixtyIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    font-weight: bold;
    color: var(--color-primary-white);
    background: var(--color-primary-black);
    border-radius: 50%;
    transition: opacity 0.3s;
    cursor: pointer;
    opacity: 0.8;
    pointer-events: all;

    &:hover {
        opacity: 1;
    }
`;

export const CenteredOverlay = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    z-index: 1;
    pointer-events: none;
`;
